export class CustomerPoint {
    constructor(customer_point) {
        this.customer_id = customer_point.customer_id;
        this.point = customer_point.point;
        this.created_at = customer_point.created_at;
        this.update_at = customer_point.update_at;
        this.lifetime_point = customer_point.lifetime_point;
    }
}